/**
* @license Apache-2.0
*
* Copyright (c) 2022 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Returns a random integer within a specified half-open interval.
*
* ## Notes
*
* -   This is not robust; however, the implementation is fine for many use cases where precise uniform sampling is not required.
*
* @private
* @param {integer} start - start of interval (inclusive)
* @param {integer} end - end of interval (exclusive)
* @returns {integer} index
*/
function random( start, end ) {
	return start + Math.floor( Math.random()*(end-start) );
}


// EXPORTS //

module.exports = random;
